<script>
  import { Tabs, TabList, TabPanel, Tab } from './Tabs/tabs.js';
  import ChangeReservationModal from './ModalOperations/ChangeReservation.svelte';
  import TransferReservationModal from './ModalOperations/TransferReservation.svelte';
  import ExtendReservationModal from './ModalOperations/ExtendReservation.svelte';
  import BreakdownModal from './ModalOperations/Breakdown.svelte';
  import SendDetailsModal from './ModalOperations/SendDetails.svelte';

  import { User } from '../store.js'; 
  import { modalReservation } from "../store";
  let reservation;
  let user;
  modalReservation.subscribe((value) => {
    reservation = value;
  });
  const unUser = User.subscribe(v => user = v);
  let message;
  let error;
  let selectedValue;
  function resetModal(){
    message = '';
    error = '';
    selectedValue = { value: "Confirmed", label: "Confirmed" };
  }
</script>

<!-- Modal -->
<div class="modal-wrapper" id="modal">
  
  <div class="modal-body card">
    
    <div class="modal-header">
      <h2 class="heading">Reservation Id: {reservation.id}</h2>
      <a href="#!" role="button" class="close" aria-label="close this modal" on:click={resetModal}>
        <svg viewBox="0 0 24 24">
          <path
            d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
          />
        </svg>
      </a>
    </div>
    <div>
      <p>
        <strong>Guest Email:</strong> {reservation.guestEmail} 
      </p>

      <p>
        <strong>Phone number:</strong> {reservation.guestPhoneNumber}
      </p>

      {#if user.accountRole.toLowerCase() === 'sysadmin' || user.accountRole.toLowerCase() === 'admin'}
        <p>
          <strong>Sell Rate:</strong> {reservation.sellRate}
        </p>
      {/if}
    </div>
    <Tabs>
      <TabList>
        <Tab>Ammend Status</Tab>
        <Tab>Transfer reservation</Tab>
        <Tab>Extend reservation</Tab>
        <Tab>Reservation Breakdown</Tab>
        <Tab>Send Details</Tab>
      </TabList>
    
      <TabPanel>
        <div class="tab-container">
          <ChangeReservationModal error={error} message={message} selectedValue={selectedValue} />
        </div>
      </TabPanel>
      <TabPanel>
        <div class="tab-container">
          <TransferReservationModal error={error} message={message} />
        </div>
      </TabPanel>
      <TabPanel>
        <div class="tab-container">
          <ExtendReservationModal error={error} message={message} />
        </div>
      </TabPanel>
      <TabPanel>
        <div class="tab-container">
          <BreakdownModal error={error} message={message} />
        </div>
      </TabPanel>
      <TabPanel>
        <div class="tab-container">
          <SendDetailsModal error={error} message={message} />
        </div>
      </TabPanel>
    </Tabs>
  </div>
  <a href="#!" class="outside-trigger" on:click={resetModal} />
</div>

<style>
  .modal-header {
    align-items: baseline;
    display: flex;
    justify-content: space-between;
  }
  .tab-container {
    margin:20px;
  }
  .close {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    height: 16px;
    text-decoration: none;
    width: 16px;
  }
  .close > svg {
    width: 16px;
  }

  .modal-wrapper {
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
  }

  #modal {
    opacity: 0;
    transition: opacity 0.5 ease-in-out;
    visibility: hidden;
  }
  #modal > .modal-body {
    max-width: 800px;
    opacity: 0;
    top:2%;
    height:80vh;
    /*transform: translateY(-10%);*/
    transition: opacity 0.5 ease-in-out;
    width: 100%;
    z-index: 1;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
  }
  #modal:target {
    opacity: 1;
    visibility: visible;
  }
  #modal:target > .modal-body {
    opacity: 1;
    transform: translateY(1);
  }
  .outside-trigger {
    bottom: 0;
    cursor: default;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
  }

  .pink-button {
    background-color: #ed4368;
    color: #fff;
    margin-top: 10px;
    width:100%;
  }
  .red-font {
    color: rgb(194, 32, 32);
  }

  .guest-details{
    margin-top: 0;
  }
</style>
